module.exports = {

  request: function (req, token) {
    this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
  },

  response: function (res) {
    if (typeof res.data.access_token !== 'undefined') {
      let token = res.data.access_token
      return token
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/bearer.js